import { render, staticRenderFns } from "./PlanningLegend.vue?vue&type=template&id=66e8c4d2&"
import script from "./PlanningLegend.vue?vue&type=script&lang=js&"
export * from "./PlanningLegend.vue?vue&type=script&lang=js&"
import style0 from "./PlanningLegend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports